<panel width="400">
	<h1>{{'query.list-queries' | translate}}</h1>
	<list-view [emptyLabel]="'query.query-list.query-list-empty-label'">
		<header defaultSort="ascending">{{ 'query.column.query-name' | translate }}</header>
		<header></header>
		<row *listData="let query from queries" [highlighted]="selectedQuery == query" (action)="displayQuery(query)">
			<column>{{ query.name }}</column>
			<column align-right><icon (click)="deleteQuery(query)" type="trash-alt" /></column>
		</row>
	</list-view>
	<div (click)="createQuery()" class="button right confirm"> {{'query.create' | translate}}</div>
</panel>
